import InlineTextInput from '@/components/ui/inline-text-input';
import { pdkAxios } from '@/lib/pdk-axios';
import type { Trade } from '@/models/types';
import { tradesStore } from '@/stores/trades-store';
import { useMutation } from '@tanstack/react-query';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

const TradeVehicleConditionEditor = ({
  tradeId,
  initialCondition,
}: {
  tradeId: Trade['id'];
  initialCondition: string;
}) => {
  const [condition, setCondition] = useState(initialCondition);

  const updateConditionMutation = useMutation({
    onMutate: async ({ condition }: { condition: string }) => {
      tradesStore.updateTrade(tradeId, {
        condition: condition,
      });
    },
    mutationFn: async ({ condition }: { condition: string }) => {
      const response = await pdkAxios.post(
        `/trades/${tradeId}/condition`,
        // /api/trades/:trade_id/condition
        {
          condition,
        },
      );

      return response.data;
    },
    onSuccess: () => {},
    onError: (error, variables) => {
      console.error('Error updating condition', error, variables);
      // TODO: handle error by adding the original cdkId back to the store
    },
  });

  const handleConditionChange = useCallback(
    debounce((newCondition: string) => {
      updateConditionMutation.mutate({ condition: newCondition });
    }, 1000),
    [],
  );

  useEffect(() => {
    if (condition === initialCondition) return;

    handleConditionChange(condition);
  }, [condition]);

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setCondition(e.target.value);
  }, []);

  useEffect(() => {
    setCondition(initialCondition);
  }, [initialCondition]);

  return (
    <div className="flex flex-row gap-1 items-center justify-between">
      <div className="flex flex-row gap-1 items-center">
        <div className="text-sm text-gray-500 dark:text-white">Condition</div>
      </div>
      <InlineTextInput
        value={condition}
        onChange={onChange}
        placeholder="Enter condition"
        className="text-right"
        wrapperClassName="gap-1"
      />
    </div>
  );
};

export default TradeVehicleConditionEditor;
